//
// Text truncation
//

.text-truncate {
  @include text-truncate();
}
